import React from 'react'
import Profile from "../Images/Profile-Image.jpeg"
import "./Home.css"
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MongoDB from "../Images/MongoDB_Logo.svg.png"
import NodeJS from "../Images/nodejs-1-logo.png"
import  ReactJS from "../Images/React-icon.svg.png"

export default function Home() {

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, 
  };
  return (
    <div >

      <div className='Hero'>
        <img src={Profile} className='img-profile' />

        <h1 className='desc'>

          Hi , I am Malik Faraz  ReactJS Developer who is passionate about web development and AI. He wants to learn more about the Web development technologies and the combination of how AI and Web can be an effective advancement to technology.


        </h1>

      </div>
      <div className='slide-box'>

        <h1 className='txt-title'>Some Tech Stacks I Know</h1>


        <Slider {...settings}>
          <div className="slide">
            <img src={MongoDB} className='images-slider' alt="Profile 1" />
          </div>
          <div className="slide">
            <img src={NodeJS } className='images-slider' alt="Profile 2" />
          </div>
          <div className="slide">
            <img src={ReactJS} className='images-slider' alt="Profile 3" />
          </div>
        </Slider>



      </div>




    </div>


  )
}
